import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { AlertCircle, CheckCircle, UserPlus } from "lucide-react";

const AdminSetup = () => {
  const [credentials, setCredentials] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [success, setSuccess] = useState(false);

  const { createAdminUser } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    setLoading(true);
    setMessage("");
    setSuccess(false);

    const result = await createAdminUser(credentials.email, credentials.password);

    if (result.success) {
      setMessage("Admin account created successfully! You can now sign in.");
      setSuccess(true);
      setCredentials({ email: "", password: "" });
    } else {
      setMessage(result.error);
      setSuccess(false);
    }

    setLoading(false);
  };

  const handleChange = (e) => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className="container-fluid vh-100 d-flex align-items-center justify-content-center bg-light">
      <div className="col-11 col-sm-8 col-md-6 col-lg-5 col-xl-4">
        <div className="card shadow-lg border-0 rounded-4 p-4 p-sm-5">
          <div className="card-body">
            <div className="text-center mb-4">
              <div className="d-flex justify-content-center mb-4">
                <div className="bg-primary-subtle p-3 rounded-circle">
                  <UserPlus className="text-primary" size={40} />
                </div>
              </div>
              <h2 className="h3 fw-bold mb-1">Create Admin Account</h2>
              <p className="text-muted">Set up your first super admin account</p>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label htmlFor="email" className="form-label">
                  Email
                </label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  required
                  value={credentials.email}
                  onChange={handleChange}
                  className="form-control form-control-lg"
                  placeholder="Enter admin email"
                  disabled={loading}
                />
              </div>

              <div className="mb-3">
                <label htmlFor="password" className="form-label">
                  Password
                </label>
                <input
                  id="password"
                  name="password"
                  type="password"
                  required
                  value={credentials.password}
                  onChange={handleChange}
                  className="form-control form-control-lg"
                  placeholder="Enter password (min 6 characters)"
                  disabled={loading}
                  minLength={6}
                />
              </div>

              {message && (
                <div
                  className={`alert ${success ? 'alert-success' : 'alert-danger'} d-flex align-items-center`}
                  role="alert"
                >
                  {success ? (
                    <CheckCircle className="me-2" size={20} />
                  ) : (
                    <AlertCircle className="me-2" size={20} />
                  )}
                  <div>{message}</div>
                </div>
              )}

              <div className="d-grid mt-4">
                <button
                  type="submit"
                  disabled={loading}
                  className="btn btn-primary btn-lg"
                >
                  {loading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Creating Account...
                    </>
                  ) : (
                    "Create Admin Account"
                  )}
                </button>
              </div>
            </form>

            {success && (
              <div className="text-center mt-4">
                <a href="/login" className="btn btn-outline-primary">
                  Go to Login
                </a>
              </div>
            )}
          </div>
        </div>
        
        <div className="text-center mt-4">
          <small className="text-muted">
            This setup page should be removed after creating your admin account
          </small>
        </div>
      </div>
    </div>
  );
};

export default AdminSetup;
